import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/internal/Observable';
import {from} from 'rxjs';
import {map} from 'rxjs/operators';
import * as _ from "lodash";
import {TranslateService} from '@ngx-translate/core';
import {BaseclientService} from '../../apiclient/baseclient.service';

@Injectable({
  providedIn: 'root'
})

export class RubricService {

  constructor(
    private translate: TranslateService,
    private baseClient: BaseclientService
  ) {
    // Constructor
  }

  /**
   * @description Récupère les rubriques du commerçant
   * @param {Object} prodsData
   * @return {array} Les rubriques attachés au commerçant qui correspondent aux produits du moment
   */
  getRubrics(prodsData: any): Observable<any> {

    return from(this.baseClient.postBaseApi("rubrics")).pipe(
      map(data => {

        // Trie les rubriques, ne garde que les rubriques attachées à un produit existant
        const parsedRubs = this.parseRubs(data, prodsData.products);

        //creation de la rubrique favorite
        if (prodsData.favorite) {

          this.translate.get('product.favoriteCat').subscribe((trad: string) => {

            let favoriterubric: any = {
              id: "favorite",
              name: trad,
              id_parent: 1,  //0 pour voir la rubrique 1 pour cacher
              childs: [],
              products: [],
              image: [],
              color: "#ffffff",
              font: true
            };

            //on push dans le tableau

            for (let h = 0; h < prodsData.products.length; h++) {
              if (prodsData.products[h].favorite) {
                favoriterubric.products.push(prodsData.products[h]);
              }
            }

            /**
             * On trie les catégories par favorite_count
             */
            if (favoriterubric && favoriterubric.products && favoriterubric.products.length > 0) {
              favoriterubric.products = favoriterubric.products.sort(function (a: any, b: any) {
                return b.favorite_count - a.favorite_count;
              });
            }

            parsedRubs.unshift(_.cloneDeep(favoriterubric));
          });
        }

        // Si au moins un produit a une promotion (Prix par rapport à un créneau) alors on ajoute la rubrique promotion au tableau des rubriques
        if (prodsData.promo) {

          // Récupération de la traduction du nom de la rubrique promo
          this.translate.get('product.promoCat').subscribe((trad: string) => {

            let promorubric: any = {
              id: "promo",
              name: trad,
              id_parent: 0,
              childs: [],
              products: []
            };


            // Parcourir les produits et pousser dans la rubrique les produits en promo
            for (let j = 0; j < prodsData.products.length; j++) {
              if (prodsData.products[j].prices.length > 0 && prodsData.products[j].prices[0].id_price_period) {

                promorubric.products.push(prodsData.products[j]);
              }
            }

            // parsedRubs.unshift( promorubric);

            parsedRubs.unshift(_.cloneDeep(promorubric));

          });


        }


        //affichage des produits avec offset et limit

        let total = 0;
        //total des produits
        parsedRubs.map((el: any) => {
          total += el.products.length;
          el.prodTotal = total;
        })


        //on cree la rubrique see All
        this.translate.get('Cat_all').subscribe((traduction: string) => {

          let allrubric = {
            id: "all",
            name: traduction,
            id_parent: 0,
            childs: [],
            products: [],
            image: [],
            color: "#0f6eca",
            prod_start: 0,
            prodTotal: total

          };


          parsedRubs.unshift(allrubric);
        })


        let newRubs = this.createConttodisplay(parsedRubs);

        return newRubs;


        //  return parsedRubs;

      })
    )
  }


  /**
   * @description on integre des variables compteur ect pour faciliter l'affichage avec des limits
   *
   * @return {array}
   */
  createConttodisplay(parsedRubs: any) {
    let Rubs = _.cloneDeep(parsedRubs);
    let compteur = 0;
    for (let index = 0; index < Rubs.length; index++) {
      const rub = Rubs[index];

      rub.rublength = Rubs.length;
      rub.rubpos = index + 1;
      // rub.prodlength = rub.products.length;

      for (let i = 0; i < rub.products.length; i++) {

        let prod_copy = _.cloneDeep(rub.products[i])
        compteur++;
        prod_copy.posComp = compteur;
        rub.products[i].posComp = prod_copy.posComp


      }
      if (rub.products && rub.products[0] && rub.products[0].posComp) {
        rub.prod_start = (rub.products[0].posComp) - 1;
        rub.prod_end = (rub.products.length + rub.products[0].posComp) - 1;
      }


    }
    return Rubs;

  }


  /**
   * @description Compare et trie les rubriques et les produits pour ne renvoyer que les rubriques qui correspondent au moins à un produit du moment
   * @param {array} rubrics
   * @param {array} prods
   * @return {array}
   */
  parseRubs(rubrics: any, prods: any[]): any {

    let parsedRubs = [];

    /**
     * On associe les produits aux rubrics
     */
    for (let i = 0; i < rubrics.list.length; i++) {

      let rub = rubrics.list[i];

      /**
       * Initialisation du tableau de produit de la rubrique
       */
      rub.products = [];

      for (let y = 0; y < prods.length; y++) {

        let prod = prods[y];

        /**
         * Si le produit correspond à la catégorie
         */
        if (prod.rubric.id === rub.id) {

          /**
           * On associe le produit à la rubrique
           */
          rub.products.push(prod);
        }
      }
    }

    /**
     * On remplace les tableaux d'id childs par l'objet de la catégorie en question
     * Puis on ajoute index_filter à l'objet rub
     */
    let indexFilter = 0;
    for (let i = 0; i < rubrics.list.length; i++) {
      const rubric = rubrics.list[i];
      const parsedChilds = [];

      if (!rubric.index_filter) {
        rubric.index_filter = i;
      }

      if (rubric.childs.length > 0) {

        for (let j = 0; j < rubric.childs.length; j++) {
          const childRubId = rubric.childs[j];

          for (let k = 0; k < rubrics.list.length; k++) {
            const rubric2 = rubrics.list[k];

            if (childRubId === rubric2.id) {

              if (rubric2.products.length > 0) {
                rubric2.index_filter = indexFilter;
                indexFilter++;
                parsedChilds.push(rubric2);
              }

              break;
            }
          }
        }
      }

      rubric.childs = _.sortBy(parsedChilds, [function (o) {
        return o.order_name;
      }]);
      indexFilter++;
    }


    /**
     * On dissocie les catégories enfants des catégories principales en les pushant dans parsedRubs
     * tout en gardant seulement les rubriques qui ont des produits
     */
    for (let i = 0; i < rubrics.list.length; i++) {

      let rub = rubrics.list[i];

      /**
       * Si le produit correspond à la catégorie
       */
      if (rub.products.length > 0 || rub.childs.length > 0) {

        /**
         * On push la catégorie dans le tableau à retourner
         */
        parsedRubs.push(rub);

      } else if (rub.childs.length > 0) {

        for (let z = 0; z < rub.childs.length; z++) {
          let srub = rub.childs[z];

          if (srub.products.length > 0) {
            parsedRubs.push(rub);
            break;
          }

        }

      }


    }

    /**
     * On trie les catégorie par index_filter
     */
    parsedRubs = _.sortBy(parsedRubs, [function (o) {
      return o.order_name;
    }]);

    return parsedRubs;
  }


  /**
   * @description Compare et trie les rubriques et les produits pour ne renvoyer que les rubriques qui correspondent au moins à un produit du moment
   * @param {array} rubrics
   * @param {array} prods
   * @return {array}
   */
  parseRubs__(rubrics: any, prods: any[]): any {

    let parsedRubs = [];

    /**
     * On associe les produits aux formules
     */
    for (let i = 0; i < rubrics.list.length; i++) {

      let rub = rubrics.list[i];

      /**
       * Initialisation du tableau de produit de la rubrique
       */
      rub.products = [];

      for (let y = 0; y < prods.length; y++) {

        let prod = prods[y];

        /**
         * Si le produit correspond à la catégorie
         */
        if (prod.rubric.id === rub.id) {

          /**
           * On associe le produit à la rubrique
           */
          rub.products.push(prod);
        }

      }

    }

    /**
     * On remplace les tableaux d'id childs par l'objet de la catégorie en question
     * Puis on ajoute index_filter à l'objet rub
     */
    let indexFilter = 0;
    for (let i = 0; i < rubrics.list.length; i++) {
      const rubric = rubrics.list[i];
      const parsedChilds = [];

      if (!rubric.index_filter) {
        rubric.index_filter = i;
      }

      if (rubric.childs.length > 0) {

        for (let j = 0; j < rubric.childs.length; j++) {
          const childRubId = rubric.childs[j];

          for (let k = 0; k < rubrics.list.length; k++) {
            const rubric2 = rubrics.list[k];

            if (childRubId === rubric2.id) {


              rubric2.index_filter = indexFilter;
              indexFilter++;
              parsedChilds.push(rubric2);


              break;
            }

          }

        }

      }

      rubric.childs = _.sortBy(parsedChilds, [function (o) {
        return o.order_name;
      }]);
      indexFilter++;
    }


    /**
     * On dissocie les catégories enfants des catégories principales en les pushant dans parsedRubs
     * tout en gardant seulement les rubriques qui ont des produits
     */
    for (let i = 0; i < rubrics.list.length; i++) {

      let rub = rubrics.list[i];

      /**
       * Si le produit correspond à la catégorie
       */
      if (rub.products.length > 0 || rub.childs.length > 0) {

        /**
         * On push la catégorie dans le tableau à retourner
         */
        parsedRubs.push(rub);

      } else if (rub.childs.length > 0) {

        for (let z = 0; z < rub.childs.length; z++) {
          let srub = rub.childs[z];

          if (srub.products.length > 0) {
            parsedRubs.push(rub);
            break;
          }

        }

      }


    }

    /**
     * On trie les catégorie par index_filter
     */
    parsedRubs = _.sortBy(parsedRubs, [function (o) {
      return o.order_name;
    }]);

    return parsedRubs;
    return rubrics
  }

  /**
   * Récupération de la liste des rubriques pour le mode de vente
   * @param idSaleMethod Identifiant mode de vente
   * @param idPointOfSale Identifiant point de vente
   */
  getRubricsBySm(idSaleMethod: any, idPointOfSale : any): Observable<any> {

    const params = {
      id_sale_method: idSaleMethod,
      id_point_of_sale: idPointOfSale
    }

    return from(this.baseClient.postBaseApi("rubrics_sm", params)).pipe(
      map(data => {
        return data.list;
      })
    )
  }

  /**
   * @description set les rubrics
   * @param {Object} rubrics
   *
   */
  setRubrics(rubrics: any, prodsDataPricePeriod?: any) {

    // Trie les rubriques
    let parsedRubs: any = this.parseRubs_(rubrics);

    //on cree la rubrique see All
    this.translate.get('Cat_all').subscribe((traduction: string) => {

      let allrubric = {
        id: "all",
        name: traduction,
        id_parent: 0,
        childs: [],
        products: [],
        image: [],
        color: "#0f6eca",
        prod_start: 0,
        prodTotal: 0

      };

      parsedRubs.unshift(allrubric);
    })

    return parsedRubs;

  }


  /* @description Récupère les rubriques du commerçant
   * @param {Object} prodsData
   * @return {array} Les rubriques attachés au commerçant qui correspondent aux produits du moment
   */
  setRubricsPricePeriod(parsedRubs: any, prodsData: any, rubric_promo?: any) {


    // Si au moins un produit a une promotion (Prix par rapport à un créneau) alors on ajoute la rubrique promotion au tableau des rubriques
    if (prodsData && prodsData.products && prodsData.products.length > 0) {

      prodsData.products.forEach((element: any) => {
        if (element.product_type == 2) {


        }
      });

      // Récupération de la traduction du nom de la rubrique promo
      this.translate.get('product.promoCat').subscribe((trad: string) => {

        let promorubric: any = {
          id: "promo",
          name: trad,
          id_parent: 0,
          childs: [],
          products: prodsData.products
        };


        if (!rubric_promo) {
          parsedRubs.unshift(promorubric);

        }


      });


    }

    return parsedRubs;


  }

  /* @description Récupère les rubriques du commerçant
    * @param {Object} prodsData
    * @return {array} Les rubriques attachés au commerçant qui correspondent aux produits du moment
    */
  setRubricsFavorite(parsedRubs: any, prodsData: any, rubric_favorite?: any) {

    // Si au moins un produit a une promotion (Prix par rapport à un créneau) alors on ajoute la rubrique promotion au tableau des rubriques
    if (prodsData && prodsData.products && prodsData.products.length > 0) {

      // Récupération de la traduction du nom de la rubrique promo

      this.translate.get('product.favoriteCat').subscribe((trad: string) => {

        let favoriterubric: any = {
          id: "favorite",
          name: trad,
          id_parent: 1,  //0 pour voir la rubrique 1 pour cacher
          childs: [],
          products: prodsData.products,
          image: [],
          color: "#ffffff",
          font: true
        };

        if (!rubric_favorite) {
          parsedRubs.unshift(favoriterubric);
        }
      });
    }

    return parsedRubs;
  }

  parseRubs_(rubrics: any): any {
    /**
     * On remplace les tableaux d'id childs par l'objet de la catégorie en question
     * Puis on ajoute index_filter à l'objet rub
     */
    let indexFilter = 0;
    for (let i = 0; i < rubrics.length; i++) {
      const rubric = rubrics[i];

      const parsedChilds = [];

      if (!rubric.index_filter) {
        rubric.index_filter = i;
      }

      if (rubric.childs.length > 0) {

        for (let j = 0; j < rubric.childs.length; j++) {
          const childRubId = rubric.childs[j];
          for (let k = 0; k < rubrics.length; k++) {
            const rubric2 = rubrics[k];

            if (childRubId === rubric2.id) {
              rubric2.index_filter = indexFilter;
              indexFilter++;
              parsedChilds.push(rubric2);
              break;
            }
          }
        }

      }

      rubric.childs = _.sortBy(parsedChilds, [function (o) {
        return o.order_name;
      }]);
      indexFilter++;
    }


    return rubrics;
  }


  addProdtoRubrics(rubrics: any, prods: any[], reset?: any) {

    /**
     * On associe les produits aux formules
     */
    for (let i = 0; i < rubrics.length; i++) {

      let rub = rubrics[i];

      /**
       * Initialisation du tableau de produit de la rubrique
       */

      rub.products = reset || !rub.products ? [] : rub.products;

      for (let y = 0; y < prods.length; y++) {

        let prod = prods[y];
        /**
         * Si le produit correspond à la catégorie
         */
        if (prod.rubric.id === rub.id) {

          /**
           * On associe le produit à la rubrique
           */
          rub.products.push(prod);
        }

      }

    }

    //affichage des produits avec offset et limit

    let total = 0;
    //total des produits
    rubrics.map((el: any) => {

      if (typeof el.id === "number") {
        total += el.products.length;
        el.prodTotal = total;
      }
    })


    rubrics.map((el: any) => {

      if (el.id == 'all') {
        el.prodTotal = total;
      }
    })


    let newRubs = this.createConttodisplay_(rubrics);

    return newRubs;

  }

  /**
   * @description on integre des variables compteur ect pour faciliter l'affichage avec des limits
   *
   * @return {array}
   */
  createConttodisplay_(parsedRubs: any) {
    let Rubs = _.cloneDeep(parsedRubs);
    let compteur = 0;
    for (let index = 0; index < Rubs.length; index++) {
      const rub = Rubs[index];

      rub.rublength = Rubs.length;
      rub.rubpos = index + 1;
      // rub.prodlength = rub.products.length;

      for (let i = 0; i < rub.products.length; i++) {

        let prod_copy = _.cloneDeep(rub.products[i])
        compteur++;
        prod_copy.posComp = compteur;
        rub.products[i].posComp = prod_copy.posComp


      }
      if (rub.products && rub.products[0] && rub.products[0].posComp) {
        rub.prod_start = (rub.products[0].posComp) - 1;
        rub.prod_end = (rub.products.length + rub.products[0].posComp) - 1;
      }
    }
    return Rubs;
  }
}



